import { Scene } from 'phaser'
import levelJson from '@/game/puzzle/assets/json/levelData.json'
import { store } from '@/store/store'

function setLoadingFalse() {
  store.dispatch('updateLoader', false)
}

export default class PlayScene extends Scene {
  constructor () {
    super({ key: 'PlayScene' })
  }

  init () {
    this.StageHeight = this.sys.game.config.height
    this.StageWidth = this.sys.game.config.width
  
    this.gameDetails = {
      blockSize: 100000,
      TopGap: 30,
      BottomGap: 30,
      LeftGap: 30,
      RightGap: 30,
      blockDiffrence: 5,
    }
  
    this.currentLevel = 2 
    this.runTimer = true
  }
  
  preload () {  
    this.load.json('levelData', levelJson)
  }
  
  create () {
    setLoadingFalse()
    this.levelData = this.cache.json.get('levelData')
  
    this.gameTimer = 0
    this.moveCount = 0
    this.currentMoveSpriteOriginal = null
  
    this.createHUD()
    this.createGridArray()
  }
  
  createHUD () {
    let bg = this.add.sprite(10, 10, 'backGround')
    bg.setOrigin(0, 0)
    bg.displayWidth = 738
    bg.displayHeight = 562
  
    this.startTimer()
  }
  
  CountMove () {
    if (this.currentMovingBlock && this.currentMoveSpriteOriginal) {
      if (this.currentMovingBlock.colPos != this.currentMoveSpriteOriginal.colPos) {
        this.moveCount++
      }
      if (this.currentMovingBlock.rowPos != this.currentMoveSpriteOriginal.rowPos) {
        this.moveCount++
      }
      if (this.currentMoveSpriteOriginal.player && (this.currentMovingBlock.colPos == 1 && this.currentMovingBlock.rowPos == this.totalRows)) {
        this.endGame()
      }
      this.currentMoveSpriteOriginal = null
    }
  }
  
  startTimer () {
    var gameClock = setInterval(() => {
      this.gameTimer++
      if (!this.runTimer) {
        clearInterval(gameClock)
      }
    }, 1000)
  }
  
  createGridArray () {
    this.GridArray = []
    let dataToCopy = JSON.stringify(this.levelData.levels[this.currentLevel - 1])
    let singleLevelDetails = JSON.parse(dataToCopy)
  
    this.totalRows = singleLevelDetails.rows
    this.totalCols = singleLevelDetails.cols
    
    for (let i = 0; i < this.totalRows; i++) {
      var activeYSpots = singleLevelDetails.blocks.filter(function (yLocation) {
        return yLocation.y == i + 1;
      })
  
      for (let k = 0; k < this.totalCols; k++) {
        var gridPoint = { 
          player: false,
          y: i + 1, 
          x: k + 1,
          width: 0, 
          height: 0,
          id: (i + 1) + '_' + (k + 1)
        }
        for (let m = 0; m < activeYSpots.length; m++) {
          if (activeYSpots[m].x == k + 1) {
            gridPoint.width = activeYSpots[m].width
            gridPoint.height = activeYSpots[m].height
            if (activeYSpots[m].player) {
              gridPoint.player = true
            }
          }
        }
  
        this.GridArray.push(gridPoint)
      }
    }
    this.createGrid()
  }
  
  createGrid () {
    this.backgroundBlocksArray = []
    this.blocksArray = []
    this.blocksMoveArray = []
    this.blockSize = this.gameDetails.blockSize
    var largestSizeX = (this.StageWidth - (this.gameDetails.LeftGap + this.gameDetails.RightGap)) / this.totalCols
    var largestSizeY = (this.StageHeight - (this.gameDetails.TopGap + this.gameDetails.BottomGap)) / this.totalRows
  
    if (this.blockSize > largestSizeX) {
      this.blockSize = largestSizeX
    }
    if (this.blockSize > largestSizeY) {
      this.blockSize = largestSizeY
    }

    let blockCounter = 1
  
    for (let i = 0; i < this.GridArray.length; i++) {
      let xLocation = this.gameDetails.LeftGap + (this.blockSize * (this.GridArray[i].x - 1)) + (this.gameDetails.blockDiffrence / 2)
      let yLocation = this.gameDetails.TopGap + (this.blockSize * (this.GridArray[i].y - 1)) + (this.gameDetails.blockDiffrence / 2)
  
      if (this.GridArray[i].width > 0 && this.GridArray[i].height > 0 ) {
        let playBlock = null
        
        if (this.GridArray[i].player) {
          playBlock = this.add.sprite(xLocation, yLocation, 'playerBlock').setOrigin(0).setInteractive()
          playBlock.displayWidth = this.blockSize * 2 - this.gameDetails.blockDiffrence
          playBlock.displayHeight = this.blockSize - this.gameDetails.blockDiffrence
  
        } else if (this.GridArray[i].width == 2) {
          playBlock = this.add.sprite(xLocation, yLocation, 'wideBlock').setOrigin(0).setInteractive()
          playBlock.displayWidth = this.blockSize * 2 - this.gameDetails.blockDiffrence
          playBlock.displayHeight = this.blockSize - this.gameDetails.blockDiffrence
  
        } else if (this.GridArray[i].height == 2) {
          playBlock = this.add.sprite(xLocation, yLocation, 'tallBlock').setOrigin(0).setInteractive()
          playBlock.displayWidth = this.blockSize - this.gameDetails.blockDiffrence
          playBlock.displayHeight = this.blockSize * 2 - this.gameDetails.blockDiffrence
  
        } else {
          playBlock = this.add.sprite(xLocation, yLocation, 'smallBlock_' + blockCounter).setOrigin(0).setInteractive()
          playBlock.displayWidth = this.blockSize - this.gameDetails.blockDiffrence
          playBlock.displayHeight = this.blockSize - this.gameDetails.blockDiffrence
          
          blockCounter++
        }
  
        playBlock.setDepth(2)
        playBlock.id = this.GridArray[i].y + '_' + this.GridArray[i].x
        playBlock.rowPos = this.GridArray[i].y
        playBlock.colPos = this.GridArray[i].x
        playBlock.width = this.GridArray[i].width
        playBlock.height = this.GridArray[i].height
        playBlock.player = false
  
        if (this.GridArray[i].player) {
          playBlock.player = true
          this.playerBlockItem = playBlock
        }
  
        this.input.setDraggable(playBlock)
        
        this.blocksArray.push(playBlock)
        this.blocksMoveArray.push(
          {
            id: playBlock.id, 
            rowPos: this.GridArray[i].y, 
            colPos: this.GridArray[i].x, 
            width: playBlock.width, 
            height: playBlock.height
          })
      }
    }
  
    this.currentStepping = false
    this.pointerEvents()
  }
  
  pointerEvents () {
    this.downX = null
    this.downY = null
    this.threshold = this.blockSize/4 
    let pointer = this.scene.scene.input
  
    pointer.on('dragstart', function (pointer, gameObject) {
      this.downX = pointer.x
      this.downY = pointer.y
      this.xOpen = null
      this.yOpen = null
      this.direction = null

      this.calcBlockX(gameObject)
      this.calcBlockY(gameObject)

      // for move counting
      if (this.currentMoveSpriteOriginal == null) {
        this.currentMoveSpriteOriginal = {
          player: gameObject.player,
          rowPos: this.currentMovingBlock.rowPos,
          colPos: this.currentMovingBlock.colPos
        }
      }
    }, this)

    pointer.on('drag', function (pointer, gameObject) {
      this.dragX = pointer.x
      this.dragY = pointer.y
      
      let blockMoveAmount = 0

      if ((this.dragX < this.downX - this.threshold) && (this.xOpen.left)) {
        
        this.direction = 'left'
        blockMoveAmount = Math.round(((this.dragX - this.gameDetails.LeftGap) - (this.blockSize * 0.5) ) / this.blockSize) + 1
        if (blockMoveAmount - 1 >= 0) {
          this.moveBlockX(gameObject, -1, blockMoveAmount)
        }
      } else if ( (this.dragX > this.downX + this.threshold) && (this.xOpen.right)) {
        
        this.direction = 'right'
        blockMoveAmount = Math.round(((this.dragX - this.gameDetails.LeftGap) - (this.blockSize * 0.5) ) / this.blockSize) + 1
        if (blockMoveAmount <= (this.totalCols - (gameObject.width - 1))) {
          this.moveBlockX(gameObject, 1, blockMoveAmount)
        }
      }

      if ( (this.dragY < this.downY - this.threshold) && (this.yOpen.up) ) {
        this.direction = 'up'
        blockMoveAmount = Math.round(((this.dragY - this.gameDetails.TopGap) - (this.blockSize * 0.5) ) / this.blockSize) + 1
        if (blockMoveAmount - 1 >= 0) {
          this.moveBlockY(gameObject, -1, blockMoveAmount)
        }
      } else if ( (this.dragY > this.downY + this.threshold) && (this.yOpen.down) ) {
        this.direction = 'down'
        blockMoveAmount = Math.round(((this.dragY - this.gameDetails.TopGap) - (this.blockSize * 0.5) ) / this.blockSize) + 1
        if (blockMoveAmount <= (this.totalRows - (gameObject.height - 1))) {
          this.moveBlockY(gameObject, 1, blockMoveAmount)
        }
      }
    }, this)

    pointer.on('dragend', function (pointer, gameObject) {
      this.CountMove()
    }, this)
  }

  updatePointer (oriantation, gameObject) {
    this.calcBlockX(gameObject)
    this.calcBlockY(gameObject)
    if (oriantation == 'X') {
      this.downX = this.dragX
    } else {
      this.downY = this.dragY
    }
  }

  moveBlockX (gameObject, direction, amount) {
    if (direction == -1 && amount > this.currentMovingBlock.colPos) {
      return 'No Move'
    }
    this.currentMovingBlock.colPos = amount
    gameObject.x = this.gameDetails.LeftGap + ((this.currentMovingBlock.colPos - 1) * this.blockSize) + (this.gameDetails.blockDiffrence / 2)
    this.updatePointer('X', gameObject)
  }

  moveBlockY (gameObject, direction, amount) {
    if (direction == -1 && amount > this.currentMovingBlock.rowPos) {
      return 'No Move'
    }
    this.currentMovingBlock.rowPos = amount
    gameObject.y = this.gameDetails.TopGap + ((this.currentMovingBlock.rowPos - 1) * this.blockSize) + (this.gameDetails.blockDiffrence / 2)
    this.updatePointer('Y', gameObject)
  }

  calcBlockY (gameObject) {
    let upOpen = true
    let downOpen = true

    // get the current Index
    let objIndexInMoveArray = this.blocksMoveArray.findIndex(function (blockItem) {
      return blockItem.id == gameObject.id
    }, this)

    this.currentMovingBlock = this.blocksMoveArray[objIndexInMoveArray]

    // get all in the same column
    let allInSameCol = this.blocksMoveArray.filter(function (Locations) {
      return (Locations.colPos == this.blocksMoveArray[objIndexInMoveArray].colPos && Locations.id !== this.blocksMoveArray[objIndexInMoveArray].id) || (Locations.width > 1 && Locations.colPos + 1 == this.blocksMoveArray[objIndexInMoveArray].colPos)
    }, this)

    let distanceCheck = 1
    if (this.currentMovingBlock.height > 1) distanceCheck = 2

    // get extra locations needed for tall blocks
    if (this.currentMovingBlock.width > 1) {
      let extraLocations = this.blocksMoveArray.filter(function (Locations) {
        return (Locations.colPos == this.blocksMoveArray[objIndexInMoveArray].colPos + 1 && Locations.id !== this.blocksMoveArray[objIndexInMoveArray].id) || (Locations.width > 1 && Locations.colPos + 1 == this.blocksMoveArray[objIndexInMoveArray].colPos)
      }, this)
      for (let item of extraLocations) {
        allInSameCol.push(item)
      }
    }

    // checks if blocks are empty
    for (let colItem of allInSameCol) {
      // Up
      if ((this.currentMovingBlock.rowPos - 1) == colItem.rowPos || ((this.currentMovingBlock.rowPos - 2) == colItem.rowPos && colItem.height == 2)) {
        upOpen = false
      }
      // Down
      if ((this.currentMovingBlock.width == 2 && ((this.currentMovingBlock.rowPos + distanceCheck) == colItem.rowPos && colItem.colPos == (this.currentMovingBlock.colPos + distanceCheck) )) || ((this.currentMovingBlock.rowPos + distanceCheck) == colItem.rowPos )) {
        downOpen = false
      }
    }
    
    this.yOpen = {
      up: upOpen,
      down: downOpen
    }
  }

  calcBlockX (gameObject) {
    let leftOpen = true
    let rightOpen = true

    // get the current Index
    let objIndexInMoveArray = this.blocksMoveArray.findIndex(function (blockItem) {
      return blockItem.id == gameObject.id
    }, this)
  
    this.currentMovingBlock = this.blocksMoveArray[objIndexInMoveArray]
    
    // get all in the same column
    let allInsameRow = this.blocksMoveArray.filter(function (Locations) {
      return (Locations.rowPos == this.blocksMoveArray[objIndexInMoveArray].rowPos && Locations.id !== this.blocksMoveArray[objIndexInMoveArray].id) || (Locations.height > 1 && Locations.rowPos + 1 == this.blocksMoveArray[objIndexInMoveArray].rowPos)
    }, this)
  
    let distanceCheck = 1
    if (this.currentMovingBlock.width > 1) distanceCheck = 2
  
    // get extra locations needed for tall blocks
    if (this.currentMovingBlock.height > 1) {
      let extraLocations = this.blocksMoveArray.filter(function (Locations) {
        return (Locations.rowPos == this.blocksMoveArray[objIndexInMoveArray].rowPos + 1 && Locations.id !== this.blocksMoveArray[objIndexInMoveArray].id) || (Locations.height > 1 && Locations.rowPos + 1 == this.blocksMoveArray[objIndexInMoveArray].rowPos)
      }, this)
      for (let item of extraLocations) {
        allInsameRow.push(item)
      }
    }
  
    for (let rowItem of allInsameRow) {
      // Left
      if ((this.currentMovingBlock.colPos - 1) == rowItem.colPos || ((this.currentMovingBlock.colPos - 2) == rowItem.colPos && rowItem.width == 2)) {
        leftOpen = false
      }
      // Right
      if ((this.currentMovingBlock.colPos + distanceCheck) == rowItem.colPos) {
        rightOpen = false

      }
    }
    
    this.xOpen = {
      left: leftOpen,
      right: rightOpen
    }
  }

  restartLevel () {
    this.clearBoard()
    setTimeout(() => {
      this.createGridArray()
    }, 150)
  }

  destroyGame () {
    this.sys.game.destroy(true);
  }

  clearBoard () {
    this.blocksArray.forEach(element => {
      element.destroy()
    })
    this.backgroundBlocksArray.forEach(element => {
      element.destroy()
    })
  }

  endGame () {
    let playerItem = this.playerBlockItem
    this.tweens.add({
      targets: playerItem,
      x: playerItem.x - 100,
      y: playerItem.y,
      ease: 'Linear',
      duration: 3000
    })

    this.tweens.add({
      targets: playerItem,
      alpha: 0,
      ease: 'Linear',
      duration: 1000
    })

    this.tweens.add({
      targets: [this.timeText, this.moveText, this.reset, this.backgroundBlocksArray, this.blocksArray, this.blocksMoveArray],
      alpha: 0,
      ease: 'Linear',
      duration: 500,
      callbackScope: this,
      delay: 750,
      onComplete: function () {
        this.scene.start('EndScene', { time: this.gameTimer, moves: this.moveCount })
      }
    })
    
    this.runTimer = false
  }
}
